import { render, staticRenderFns } from "./EditorField.vue?vue&type=template&id=a8895ee6&scoped=true"
import script from "./EditorField.vue?vue&type=script&lang=js"
export * from "./EditorField.vue?vue&type=script&lang=js"
import style0 from "./EditorField.vue?vue&type=style&index=0&id=a8895ee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8895ee6",
  null
  
)

export default component.exports